import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Container, Row, Col } from 'reactstrap';
import './login.css';
import RegisterForm from './registerForm';
import Particles from 'react-particles-js'

import { registerUser } from '../../modules/user'

class Register extends Component {

  render () {
    const { dispatch, registerErrorMessage } = this.props

    return (
      <div className="login-page">
        <Particles
          style={{position:"fixed",
                  top:0,
                  left:0,
                  height:"100%",
                  width:"100%"
                }}
            params={{
              particles: {
                number: {
                  value: 80,
                  density: {
                    enable: true,
                  }
                },
                color: {
                  value: "#ffffff"
                },
                shape: {
                  type: "circle",
                  stroke: {
                    width: 0,
                    color: "#000000"
                  },
                  polygon: {
                    nb_sides: 5
                  }
                  // ,
                  // image: {
                  //   src: img/github.svg,
                  //   width: 100,
                  //   height: 100
                  // }
                },
                opacity: {
                  value: 0.05,
                  random: false,
                  anim: {
                    enable: false,
                    speed: 1,
                    opacity_min: 0.1,
                    sync: false
                  }
                },
                size: {
                  value: 35,
                  random: true,
                  anim: {
                    enable: false,
                    speed: 40,
                    size_min: 0.1,
                    sync: false
                  }
                },
                line_linked: {
                  enable: true,
                  distance: 150,
                  color: "#ffffff",
                  opacity: 0.09,
                  width: 1.5
                },
                move: {
                  enable: true,
                  speed: 3,
                  direction: "none",
                  random: false,
                  straight: false,
                  out_mode: "out",
                  bounce: false,
                  attract: {
                    enable: false,
                    rotateX: 600,
                    rotateY: 1200
                  }
                }
              },
              interactivity: {
                detect_on: "canvas",
                events: {
                  onhover: {
                    enable: true,
                    mode: "repulse"
                  },
                  onclick: {
                    enable: true,
                    mode: "push"
                  },
                  resize: true
                },
                modes: {
                  grab: {
                    distance: 400,
                    line_linked: {
                      opacity: 1
                    }
                  },
                  bubble: {
                    distance: 400,
                    size: 40,
                    duration: 2,
                    opacity: 8,
                    speed: 3
                  },
                  repulse: {
                    distance: 200,
                    duration: 0.4
                  },
                  push: {
                    particles_nb: 4
                  },
                  remove: {
                    particles_nb: 2
                  }
                }
              }

          }}
        />
        <div className="login-wrapper">

          <div className="login-wrapper-inner">
            <Container>
              <Row>
                <Col sm="12" md="7">
                  <object aria-label="logo" className="logo" type="image/svg+xml" data="/qcats12b.svg" alt="logo" style={{float: 'left', height: '80px', width: '80px', marginRight: '.5rem', marginTop: '.8rem'}}/>
                  <h1 className="login-title text-light display-4 mb-0">Quantum CATS</h1>
                  <h4 className="login-title-subheader text-light mb-4">Codes, Analytic Tools & Simulations</h4>
                  <p className="login-text text-secondary">Quantum CATS is a web application for experimentalists to perform quantum calculations,
                  analyze results, store and reuse information.</p>
                </Col>
                <Col>
                  <div className="login-box login-register">
                    <RegisterForm
                      errorMessage={ registerErrorMessage }
                      onRegisterClick={ creds => dispatch(registerUser(creds)) }
                    />
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    )
  }
}

Register.propTypes = {
  dispatch: PropTypes.func.isRequired,
  loginErrorMessage: PropTypes.string,
  registerErrorMessage: PropTypes.string
}

// These props come from the application's
// state when it is started
function mapStateToProps(state) {
  const { user } = state;
  const registerErrorMessage = user.errorMessage

  return {
    registerErrorMessage
  }
}

export default connect(mapStateToProps)(Register)



// WEBPACK FOOTER //
// ./src/containers/login/register.js